import { FC, ReactNode } from "react"

import { baseAuthSubtitleContainer } from "./AuthSubtitle.css"

export const AuthSubtitle: FC<{ children: ReactNode }> = ({ children }) => (
  <div className={baseAuthSubtitleContainer}>{children}</div>
)
